import Actions                           from 'Redux/Actions';
import { ofType }                        from 'redux-observable';
import { from }                          from 'rxjs';
import { mergeMap, catchError }          from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';
import { EventParentCategoryRepository } from 'Domain/Repositories';
import { message }                       from 'antd';

export const createEventParentCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createEventParentCategoryRequest.type),
    mergeMap(action => from(EventParentCategoryRepository.create(action.payload.formData))
      .pipe(
        mergeMap((eventParentCategory) => {
          message.success('Event Kategorie wurde erfolgreich erstellt');
          return from([
            Actions.createEventParentCategorySuccess({ eventParentCategory })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createEventParentCategoryFailure({ error }),
          ]);
        })
      )
    ),
  );
};
